import {
  FETCH_LOYALTY_DETAILS_REQUEST,
  FETCH_LOYALTY_DETAILS_SUCCESS,
  FETCH_LOYALTY_DETAILS_FAILURE,
  RESET_LOYALTY_DETAILS,
  FETCH_STORE_LOYALTY_SETTINGS_REQUEST,
  FETCH_STORE_LOYALTY_SETTINGS_SUCCESS,
  FETCH_STORE_LOYALTY_SETTINGS_FAILURE,
  FETCH_PRE_SIGNUP_DATA_REQUEST,
  FETCH_PRE_SIGNUP_DATA_SUCCESS,
  FETCH_PRE_SIGNUP_DATA_FAILURE,
  FETCH_USER_POINTS_REQUEST,
  FETCH_USER_POINTS_SUCCESS,
  FETCH_USER_POINTS_FAILURE,
  FETCH_EARNINGS_REQUEST,
  FETCH_EARNINGS_SUCCESS,
  FETCH_EARNINGS_FAILURE,
  FETCH_PROMOTIONS_REQUEST,
  FETCH_PROMOTIONS_SUCCESS,
  FETCH_PROMOTIONS_FAILURE,
  FETCH_REDEMPTIONS_REQUEST,
  FETCH_REDEMPTIONS_SUCCESS,
  FETCH_REDEMPTIONS_FAILURE,
  FETCH_AVAILABLE_REDEMPTIONS_REQUEST,
  FETCH_AVAILABLE_REDEMPTIONS_SUCCESS,
  FETCH_AVAILABLE_REDEMPTIONS_FAILURE,
  CREATE_LOYALTY_SIGNUP_REQUEST,
  CREATE_LOYALTY_SIGNUP_SUCCESS,
  CREATE_LOYALTY_SIGNUP_FAILURE,
  STORE_LOYALTY_VOUCHER,
  SHOW_ENROLLMENT_FORM,
} from './actions';

const initialState = {
  userLoyaltyDetails: null,
  isLoading: false,
  error: null,
  storeLoyaltySettings: null,
  isLoadingSettings: true,
  settingsError: null,
  userPoints: 0,
  isLoadingPoints: false,
  pointsError: null,
  preSignupData: null,
  isLoadingPreSignupData: false,
  preSignupDataError: null,
  earnings: null,
  isLoadingEarnings: false,
  earningsError: null,
  promotions: null,
  isLoadingPromotions: false,
  promotionsError: null,
  redemptions: null,
  isLoadingRedemptions: false,
  redemptionsError: null,
  availableRedemptions: [],
  isLoadingAvailableRedemptions: false,
  availableRedemptionsError: null,
  loyaltyVoucher: null,
  isShowEnrollmentForm: false,
};

const loyaltyReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_LOYALTY_DETAILS_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case FETCH_LOYALTY_DETAILS_SUCCESS:
      return {
        ...state,
        userLoyaltyDetails: action.payload,
        isLoading: false,
        error: null,
      };
    case FETCH_LOYALTY_DETAILS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    case RESET_LOYALTY_DETAILS:
      return {
        ...state,
        userLoyaltyDetails: null,
        isLoading: false,
        error: null,
      };
    case FETCH_STORE_LOYALTY_SETTINGS_REQUEST:
      return {
        ...state,
        isLoadingSettings: true,
        settingsError: null,
      };
    case FETCH_STORE_LOYALTY_SETTINGS_SUCCESS:
      return {
        ...state,
        storeLoyaltySettings: action.payload,
        isLoadingSettings: false,
        settingsError: null,
      };
    case FETCH_STORE_LOYALTY_SETTINGS_FAILURE:
      return {
        ...state,
        isLoadingSettings: false,
        settingsError: action.payload,
      };
    case FETCH_USER_POINTS_REQUEST:
      return {
        ...state,
        isLoadingPoints: true,
        pointsError: null,
      };
    case FETCH_USER_POINTS_SUCCESS:
      return {
        ...state,
        userPoints: action.payload,
        isLoadingPoints: false,
        pointsError: null,
      };
    case FETCH_USER_POINTS_FAILURE:
      return {
        ...state,
        isLoadingPoints: false,
        pointsError: action.payload,
      };
    case FETCH_PRE_SIGNUP_DATA_REQUEST:
      return {
        ...state,
        isLoadingPreSignupData: true,
        preSignupDataError: null,
        isLoadingEarnings: true,
        isLoadingPromotions: true,
        isLoadingRedemptions: true,
      };
    case FETCH_PRE_SIGNUP_DATA_SUCCESS:
      return {
        ...state,
        preSignupData: action.payload,
        isLoadingPreSignupData: false,
        preSignupDataError: null,
      };
    case FETCH_PRE_SIGNUP_DATA_FAILURE:
      return {
        ...state,
        isLoadingPreSignupData: false,
        preSignupDataError: action.payload,
        isLoadingEarnings: false,
        earningsError: action.payload,
        isLoadingPromotions: false,
        promotionsError: action.payload,
        isLoadingRedemptions: false,
        redemptionsError: action.payload,
      };
    case FETCH_EARNINGS_REQUEST:
      return {
        ...state,
        isLoadingEarnings: true,
        earningsError: null,
      };
    case FETCH_EARNINGS_SUCCESS:
      return {
        ...state,
        earnings: action.payload,
        isLoadingEarnings: false,
        earningsError: null,
      };
    case FETCH_EARNINGS_FAILURE:
      return {
        ...state,
        isLoadingEarnings: false,
        earningsError: action.payload,
      };
    case FETCH_PROMOTIONS_REQUEST:
      return {
        ...state,
        isLoadingPromotions: true,
        promotionsError: null,
      };
    case FETCH_PROMOTIONS_SUCCESS:
      return {
        ...state,
        promotions: action.payload,
        isLoadingPromotions: false,
        promotionsError: null,
      };
    case FETCH_PROMOTIONS_FAILURE:
      return {
        ...state,
        isLoadingPromotions: false,
        promotionsError: action.payload,
      };
    case FETCH_REDEMPTIONS_REQUEST:
      return {
        ...state,
        isLoadingRedemptions: true,
        redemptionsError: null,
      };
    case FETCH_REDEMPTIONS_SUCCESS:
      return {
        ...state,
        redemptions: action.payload,
        isLoadingRedemptions: false,
        redemptionsError: null,
      };
    case FETCH_REDEMPTIONS_FAILURE:
      return {
        ...state,
        isLoadingRedemptions: false,
        redemptionsError: action.payload,
      };
    case FETCH_AVAILABLE_REDEMPTIONS_REQUEST:
      return {
        ...state,
        isLoadingAvailableRedemptions: true,
        availableRedemptionsError: null,
      };
    case FETCH_AVAILABLE_REDEMPTIONS_SUCCESS:
      return {
        ...state,
        availableRedemptions: action.payload,
        isLoadingAvailableRedemptions: false,
        availableRedemptionsError: null,
      };
    case FETCH_AVAILABLE_REDEMPTIONS_FAILURE:
      return {
        ...state,
        isLoadingAvailableRedemptions: false,
        availableRedemptionsError: action.payload,
      };
    case CREATE_LOYALTY_SIGNUP_REQUEST:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case CREATE_LOYALTY_SIGNUP_SUCCESS:
      return {
        ...state,
        userLoyaltyDetails: action.payload,
        isLoading: false,
        error: null,
      };
    case CREATE_LOYALTY_SIGNUP_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    case STORE_LOYALTY_VOUCHER:
      return {
        ...state,
        loyaltyVoucher: action.payload,
      };
    case SHOW_ENROLLMENT_FORM:
      return {
        ...state,
        isShowEnrollmentForm: action.payload,
      };
    default:
      return state;
  }
};

export default loyaltyReducer;
